import { ReferralJustificationQuestionsFormValues } from '@/pages/referClient/steps/2_ReferralDetails/components/ReferralJustificationQuestion/types'

export const REFERRAL_JUSTIFICATIONS_QUESTIONS: Record<
  keyof ReferralJustificationQuestionsFormValues,
  keyof ReferralJustificationQuestionsFormValues
> = {
  referralJustification: 'referralJustification',
}
